import * as React from "react";
import { Box, Button, Drawer, IconButton, Stack } from "@mui/material";
import Typography from "@mui/material/Typography";
import { GearIcon, XIcon } from "@phosphor-icons/react";

export function CustomDrawer({
	open,
	onClose,
	children,
	title,
	onSubmit,
	submitButtonText = "Submit",
	isSubmitButtonDisabled = false,
	width = "600px",
}: {
	open: boolean;
	onClose: () => void;
	children: React.ReactNode;
	title: string;
	onSubmit: (data: any) => void;
	submitButtonText: string;
	isSubmitButtonDisabled: boolean;
	width?: string;
}): React.JSX.Element {
	return (
		<Drawer
			anchor="right"
			open={open}
			onClose={onClose}
			slotProps={{
				backdrop: { invisible: true },
				paper: {
					sx: {
						width: width,
						maxWidth: "100dvw",
						flex: 1,
						backgroundImage: "none",
						backgroundColor: "background.paper",
						display: "flex",
						flexDirection: "column",
						overflow: "hidden",
					},
				},
			}}
		>
			<Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
				<Box
					sx={{
						display: "flex",
						justifyContent: "space-between",
						alignItems: "center",
						py: 2,
						px: 2.5,
						borderBottom: "1px solid",
						borderColor: "divider",
					}}
				>
					<Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
						<GearIcon fontSize="var(--icon-fontSize-md)" />
						<Typography variant="h6">{title}</Typography>
					</Stack>
					<Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
						<IconButton size="small" onClick={onClose}>
							<XIcon fontSize="var(--icon-fontSize-md)" />
						</IconButton>
					</Stack>
				</Box>

				<Box sx={{ flex: 1, overflowY: "auto", p: 2.5, overflowX: "hidden" }}>{children}</Box>

				<Box
					sx={{
						display: "flex",
						justifyContent: "flex-end",
						alignItems: "center",
						py: 2,
						px: 2.5,
						borderTop: "1px solid",
						borderColor: "divider",
					}}
				>
					<Stack direction="row" spacing={1}>
						<Button variant="outlined" onClick={onClose}>
							Cancel
						</Button>
						<Button variant="contained" onClick={onSubmit} disabled={isSubmitButtonDisabled}>
							{submitButtonText}
						</Button>
					</Stack>
				</Box>
			</Box>
		</Drawer>
	);
}
